// This component depends on being within a parent x-data scope
// where shopifyData is defined

import { createDebouncer } from '~/js/utilities';

const initializeButtons = () => {
  window.SwymCallbacks.push((swat) => {
    swat.initializeActionButtons('body');
  });
};

const initializeButtonsDebounced = createDebouncer((cb) => setTimeout(cb, 0))(
  initializeButtons
);

const addToWishlistButton = () => ({
  get productForWishlist() {
    if (!this.shopifyData) {
      return null;
    }

    const { shopifyData } = this;

    const { parentSelectedVariants: selectedVariants } = this;

    const variantId = (
      selectedVariants?.[0]?.id || shopifyData.variants[0].id
    ).replace('gid://shopify/ProductVariant/', '');

    return {
      id: shopifyData.id.replace('gid://shopify/Product/', ''),
      variantId,
      url: shopifyData.onlineStoreUrl,
    };
  },

  init() {
    const whenReady = async () => {
      await this.$nextTick();
      initializeButtonsDebounced();
    };

    if (this.productForWishlist?.id) {
      whenReady();
    } else {
      this.$watch('productForWishlist?.id', whenReady);
    }
  },
});

export default addToWishlistButton;
